import { APPCONSTANTS } from '../constants/AppConstants';

export async function addEnquiry(requestObj) {
  const ADDENQUIRY_URL =
    APPCONSTANTS.API.BASEURL + APPCONSTANTS.API.AddEnquiry;

  const response = await fetch(ADDENQUIRY_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*"
    },
    body: JSON.stringify(requestObj)
  });

  const data = await response.text(); // read once

  if (!response.ok) {
    throw new Error(data || "Registration failed");
  }

  return data ? JSON.parse(data) : {};
}




